import React from 'react';

export const CheckmarkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <path d="M1.33325 4.50008L3.33325 6.83341L6.99992 1.16675" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default CheckmarkIcon;
